module.exports = __webpack_public_path__ + "media/react/features/event-creation-wizard/steps/event-areas/assets/expo-cb2da1fa5e73cfdcf174be3ff231fa6c.png";